import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { saveBlob } from "@/components/BackupPanel";
import { useAuth } from "@/context/AuthContext";

export const WH_NAMES = { mercatino: "Mercatino dell'usato", zgh: "ZoolashGamingHouse" };
const KEY = "suk_wh";

export function useWh() {
  const { user } = useAuth();
  const [wh, setW] = useState(() => localStorage.getItem(KEY) || "mercatino");
  useEffect(() => {
    const f = () => setW(localStorage.getItem(KEY) || "mercatino");
    window.addEventListener("suk-wh", f);
    return () => window.removeEventListener("suk-wh", f);
  }, []);
  const allowed = user && (user.role === "admin" || user.wh_access?.includes("zgh")) ? ["mercatino", "zgh"] : ["mercatino"];
  const setWh = (v) => { localStorage.setItem(KEY, v); window.dispatchEvent(new Event("suk-wh")); };
  return { wh: allowed.includes(wh) ? wh : "mercatino", setWh, allowed };
}

export const eurOr = (v) => (v == null ? "—" : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v));

export const WH_STATUS = {
  disponibile: ["Disponibile", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  venduto: ["Venduto", "bg-amber-50 text-amber-800 border-amber-200"],
  rimosso: ["Rimosso", "bg-zinc-100 text-zinc-600 border-zinc-300"],
};

export const REASONS = [["danneggiato", "Danneggiato"], ["smaltito", "Smaltito"], ["smarrito", "Smarrito"], ["ritirato", "Ritirato"], ["altro", "Altro"]];

export const MOVE_LABELS = {
  inserimento: "Inserimento", modifica: "Modifica", vendita: "Vendita", rimozione: "Rimozione",
  ripristino: "Ripristino", trasferimento: "Trasferimento", eliminazione: "Eliminazione",
};

export const FIELD_LABELS = {
  description: "Descrizione", category: "Categoria", subcategory: "Sottocategoria", color: "Colore", brand: "Marca", model: "Modello",
  condition: "Condizioni", defects: "Difetti", notes: "Note interne", location: "Posizione", purchase_price: "Prezzo acquisto",
  sale_price: "Prezzo vendita", extra_costs: "Costi aggiuntivi", photos: "Foto", quantity: "Quantità",
};

export const base = () => window.location.origin;

export async function download(url, params, name) {
  const res = await api.get(url, { params: { ...params, base: base() }, responseType: "blob" });
  saveBlob(res.data, name);
}

export const StatusBadge = ({ status }) => {
  const [l, c] = WH_STATUS[status] || WH_STATUS.disponibile;
  return <span className={`shrink-0 text-[11px] font-semibold px-2.5 py-1 rounded-full border ${c}`} data-testid="wh-status-badge">{l}</span>;
};
